import { render, staticRenderFns } from "./productsAr.vue?vue&type=template&id=f775582a&"
import script from "./productsAr.vue?vue&type=script&lang=js&"
export * from "./productsAr.vue?vue&type=script&lang=js&"
import style0 from "./productsAr.vue?vue&type=style&index=0&id=f775582a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports